// Simon run 2 (R2-008, D8): numbers and amounts in the person's own format.
// Every money and number helper of the web app ends in @convenor/shared's
// formatNumber, which writes the style set by setNumberFormat. This keeps that
// style in step with the signed-in person: whenever /api/me lands in the query
// cache (sign-in, a refresh, a save on the Account page), and back to European
// when it leaves (sign-out clears the cache). Call sites do not change.
import type { QueryClient } from "@tanstack/react-query";
import { setNumberFormat, type NumberFormat } from "@convenor/shared";
import { qk } from "../api/keys";

type WithNumberFormat = { user?: { numberFormat?: NumberFormat } | null } | null | undefined;

/** Follows the person's number format from the cached /api/me. Returns the unsubscribe. */
export function followNumberFormat(client: QueryClient): () => void {
  const apply = () => setNumberFormat((client.getQueryData(qk.me) as WithNumberFormat)?.user?.numberFormat);
  apply();
  return client.getQueryCache().subscribe((event) => {
    if (event.query.queryKey[0] === qk.me[0]) apply();
  });
}
